module.exports = __webpack_public_path__ + "static/media/mapColor.b6bbab69.svg";